import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import { Injectable } from "@angular/core";
import { environment } from '../../../environments/environment';

@Injectable()
export class AddXsrfTokenHttpRequestInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip XSRF token for OIDC/Keycloak endpoints
    if (req.url.startsWith(environment.idmAuthURL)) {
      return next.handle(req);
    }

    let token = '';
    const cookieValues: string[] =  document.cookie.split(';');
    for (const value of cookieValues) {
      if (value.trim().startsWith('XSRF-TOKEN')) {
        token = value.split('=')[1].trim();
        break;
      }
    }
    // Clone the request to add the new header
    const clonedRequest = req.clone({ headers: req.headers.set('X-XSRF-TOKEN', token) });

    // Pass the cloned request instead of the original request to the next handle
    return next.handle(clonedRequest);
  }
}
